import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { ButtonV3Component, SelectOption, SelectV2Module } from '@gea/digital-ui-lib';
import { Router } from '@angular/router';
import { TopProducts } from '../../../pages/dashboard/dashboard.model';
import { CarouselModule } from 'primeng/carousel';
import { NgClass } from '@angular/common';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'app-dashboard-products-card',
  imports: [SelectV2Module, CarouselModule, ButtonV3Component, NgClass, Skeleton],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dashboard-products-card.component.html',
  styleUrl: './dashboard-products-card.component.scss',
})
export class DashboardProductsCardComponent {
  topProducts: TopProducts = {
    title: '',
    products: [],
  };
  selectedProduct!: SelectOption;
  @Input() set topProductsKPIData(topProducts: TopProducts) {
    this.topProducts = topProducts;
    if (topProducts.products.length) {
      this.selectedProduct = this.topProducts.products[0];
    }
  }

  currentPage = 0;
  @Input() isLoading = signal<boolean>(true);

  constructor(private router: Router) {}

  goToProductsPage(option: SelectOption): void {
    this.selectedProduct = option;
    this.router.navigate(['/products']);
  }

  onCarouselPageNext(): void {
    ++this.currentPage;
  }

  onCarouselPagePrev(): void {
    --this.currentPage;
  }

  getProductCrownClass(product: SelectOption): string {
    const index = this.topProducts.products.indexOf(product);
    let colorClass = 'first';
    if (index === 1) {
      colorClass = 'second';
    } else if (index === 2) {
      colorClass = 'third';
    }
    return colorClass;
  }
}
